/* global listRolesUrl listPlacesUrl listModulesUrl organisationUsersUrl isSuperAdmin supportRolesUrl listSupportUsersUrl */
/* global inviteSupportUserUrl revokeSupportUserUrl organisationSupportUsersUrl updateUserUrl deleteUserUrl */
/* global createUserUrl canEditUsers canCreateUsers canEnableUsers canDeleteUsers authId */

import React from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

import SupportUsers from '../support_users/SupportUsers';

import UsersTable from './UsersTable';
import useUsersTableData from './useUsersTableData';

function Users({ listProjectUsersUrl, canAssignEventAdmin }) {
    const { roles, departments, costcenters, revDepartments, revCostcenters, venues, organisationUsers, fetchOrganisationUsers, modules } = useUsersTableData({
        rolesUrl: listRolesUrl,
        placesUrl: listPlacesUrl,
        modulesUrl: listModulesUrl,
        organisationUsersUrl: organisationUsersUrl,
    });

    if (roles.length === 0) {
        return <div>{$t('Loading...')}</div>;
    }

    return (
        <div>
            <div>
                {!!isSuperAdmin && (
                    <SupportUsers
                        listRolesUrl={supportRolesUrl}
                        usersUrl={listSupportUsersUrl}
                        inviteUrl={inviteSupportUserUrl}
                        revokeUrl={revokeSupportUserUrl}
                        organisationSupportUsersUrl={organisationSupportUsersUrl}
                        canEdit={isSuperAdmin}
                        canCreate={isSuperAdmin}
                        canEnable={isSuperAdmin}
                        canDelete={isSuperAdmin}
                        type={'event'}
                    />
                )}
            </div>
            <div className="tw-mt-4">
                <UsersTable
                    roles={roles}
                    departments={departments}
                    costcenters={costcenters}
                    revDepartments={revDepartments}
                    revCostcenters={revCostcenters}
                    venues={venues}
                    listUsersUrl={listProjectUsersUrl}
                    updateUserUrl={updateUserUrl}
                    deleteUserUrl={deleteUserUrl}
                    storeUserUrl={createUserUrl}
                    canEdit={canEditUsers}
                    canCreate={canCreateUsers}
                    canEnable={canEnableUsers}
                    canDelete={canDeleteUsers}
                    canAssignEventAdmin={canAssignEventAdmin}
                    authId={authId}
                    organisationUsers={organisationUsers}
                    fetchOrganisationUsers={fetchOrganisationUsers}
                    modules={modules}
                />
            </div>
        </div>
    );
}

export default Users;
if (document.getElementById('AdminUsers')) {
    var rootEl = document.getElementById('AdminUsers');
    ReactDOM.render(
        <App>
            <Users
                listProjectUsersUrl={rootEl.getAttribute('data-list-url')}
                canAssignEventAdmin={JSON.parse(rootEl.getAttribute('data-can-assign-event-admin'))}
            />
        </App>,
        rootEl,
    );
}
